module.exports = __webpack_public_path__ + "img/iconIN.3a9bf0ac.svg";